// extracted by mini-css-extract-plugin
export var avatar = "Footer-module--avatar--b888a";
export var container = "Footer-module--container--64496";
export var content = "Footer-module--content--c0375";
export var duration = "Footer-module--duration--aa61f";
export var icon = "Footer-module--icon--6adce";
export var info = "Footer-module--info--f9ba5";
export var name = "Footer-module--name--e95ae";
export var position = "Footer-module--position--d9d0f";
export var social = "Footer-module--social--6e96f";
export var splitter = "Footer-module--splitter--87e59";